import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/Index'),
    },
    {
      path: '/Catalogs',//产品栏目列表
      name: 'Catalogs',
      component: () => import('@/views/Catalogs'),
    },
    {
      path: '/ContactUs',//联系我们
      name: 'ContactUs',
      component: () => import('@/views/ContactUs'),
    },
    {
      path: '/MessageUs',//在线留言
      name: 'MessageUs',
      component: () => import('@/views/MessageUs'),
    },
    {
      path: '/NewList',//新闻列表
      name: 'NewList',
      component: () => import('@/views/NewList'),
    },
    {
      path: '/NewDetail',//新闻详情-文章
      name: 'NewDetail',
      component: () => import('@/views/NewDetail'),
    },
    {
      path: '/ImageDetail',//新闻详情-图集
      name: 'ImageDetail',
      component: () => import('@/views/ImageDetail'),
    },
    {
      path: '/VideoDetail',//新闻详情-视频
      name: 'VideoDetail',
      component: () => import('@/views/VideoDetail'),
    },
    {
      path: '/SearchResult',//搜索结果页
      name: 'SearchResult',
      component: () => import('@/views/SearchResult'),
    },
    {
      path: '/CompanyQualification',//企业资质页
      name: 'CompanyQualification',
      component: () => import('@/views/CompanyQualification'),
    },
    {
      path: '/List',//新闻列表(产品)
      name: 'List',
      component: () => import('@/views/List'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js